import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PageTitle from "../../components/shared/PageTitle";
import AccountWidget from "../../components/shared/AccountWidget";
import CategoriesWidget from "../../components/shared/CategoriesWidget";
import Loading from "../../components/shared/Loading";
import FlashMessage from "../../components/shared/FlashMessage";
import {
  customerGetAddress,
  updateActiveAddress,
  removeAddress,
} from "../../store/actions/customer";
import NewAddressForm from "../../components/NewAddressForm";
import EditAddressForm from "../../components/EditAddressForm";
import { Link } from "react-router-dom";
import moment from "moment";
import "moment/locale/tr";
import "../../styles/ModernAddresses.css";
import "../../styles/ModernOrders.css";
import { formatPhoneDisplay } from "../../helpers/phoneFormatter";
moment.locale("tr");

class Address extends Component {
  state = { edit: false, addressID: null, type: null };
  componentDidMount() {
    this.props.customerGetAddress();
  }

  render() {
    if (this.props.customer.fetching) {
      return <Loading text={"Sayfa Yükleniyor..."} />;
    } else {
      if (!this.props.customer.customer) {
        return (
          <Redirect
            to={{
              pathname: "/giris-yap",
              // state: { referrer: currentLocation }
            }}
          />
        );
      }

      return (
        <React.Fragment>
          <PageTitle title={"Adreslerim"} />
          <div className="modern-addresses-container">
            <div className={"container"}>
              <div className="row">
                <div className={"col-md-9"}>
                  {/* Modern Header */}
                  <div className="modern-orders-header">
                    <div className="orders-header-content">
                      <h1 className="orders-title">
                        <FontAwesomeIcon
                          icon="map-marker-alt"
                          style={{ marginRight: "15px" }}
                        />
                        Adreslerim
                      </h1>
                      <p className="orders-subtitle">
                        Sipariş teslimat adreslerinizi yönetin ve düzenleyin
                      </p>
                      <div className="orders-breadcrumb">
                        <Link
                          to="/hesabim"
                          style={{ color: "rgba(255,255,255,0.8)" }}
                        >
                          Hesabım
                        </Link>
                        {" / "}
                        <span>Adreslerim</span>
                      </div>
                    </div>
                  </div>

                  {this.state.edit && (
                    <EditAddressForm
                      {...this.state.edit}
                      closeCallback={() => {
                        this.setState({ edit: false });
                      }}
                    />
                  )}
                  <FlashMessage />

                  {this.props.customer.addresses.length === 0 &&
                  this.props.customer.addressFetching ? (
                    <div className="addresses-loading">
                      <div className="loading-spinner"></div>
                      <div className="loading-text">Adresler Yükleniyor...</div>
                    </div>
                  ) : this.props.customer.addresses.length === 0 ? (
                    <div className="addresses-empty-state">
                      <div className="empty-state-icon">
                        <FontAwesomeIcon icon="map-marker-alt" />
                      </div>
                      <h3 className="empty-state-title">
                        Henüz Adres Eklenmemiş
                      </h3>
                      <p className="empty-state-description">
                        Sipariş verebilmek için en az bir teslimat adresi
                        eklemeniz gerekiyor. Hemen ilk adresinizi ekleyin!
                      </p>
                      <button
                        className="add-new-address-btn"
                        data-toggle="modal"
                        data-target="#exampleModal"
                        type="button"
                      >
                        <FontAwesomeIcon icon="plus" />
                        İlk Adresimi Ekle
                      </button>
                    </div>
                  ) : (
                    <React.Fragment>
                      <div className="addresses-grid">
                        {this.props.customer.addresses.map((address, i) => (
                          <div
                            key={i}
                            className="address-item"
                          >
                            <div className="address-item-header">
                              <div className="address-item-title">
                                {address.address_name}
                              </div>
                            </div>

                            <div className="address-details">
                              <div className="address-info-line">
                                <div className="address-info-text">
                                  <span className="address-full-name">
                                    {address.first_name} {address.last_name}
                                  </span>
                                </div>
                              </div>

                              <div className="address-info-line">
                                <div className="address-info-text">
                                  {address.address}
                                  <br />
                                  {address.town && `${address.town}, `}
                                  {address.city}
                                </div>
                              </div>

                              <div className="address-info-line">
                                <div className="address-info-text">
                                  {formatPhoneDisplay(address.phone)}
                                </div>
                              </div>

                              {address.invoice_type === "corporate" && (
                                <div className="address-info-line">
                                  <div className="address-info-text">
                                    <strong>{address.company_name}</strong>
                                    <br />
                                    VN: {address.tax_number} -{" "}
                                    {address.tax_office}
                                  </div>
                                </div>
                              )}
                            </div>

                            <div className="address-actions">
                              <button
                                className="address-action-btn edit-address-btn"
                                onClick={(e) => {
                                  e.preventDefault();
                                  this.setState({ edit: address });
                                }}
                              >
                                <FontAwesomeIcon icon="pencil-alt" />
                                Düzenle
                              </button>

                              <button
                                className="address-action-btn delete-address-btn"
                                disabled={
                                  this.props.customer.addressFetching &&
                                  address.id === this.state.addressID &&
                                  this.state.type === "remove"
                                }
                                onClick={(e) => {
                                  e.preventDefault();
                                  this.setState({
                                    addressID: address.id,
                                    type: "remove",
                                  });
                                  this.props.removeAddress(address.id);
                                }}
                              >
                                {this.props.customer.addressFetching &&
                                address.id === this.state.addressID &&
                                this.state.type === "remove" ? (
                                  <FontAwesomeIcon icon="spinner" spin />
                                ) : (
                                  <React.Fragment>
                                    <FontAwesomeIcon icon="trash-alt" />
                                    Sil
                                  </React.Fragment>
                                )}
                              </button>
                            </div>
                          </div>
                        ))}
                      </div>

                      <div className="add-address-section">
                        <button
                          className="add-new-address-btn"
                          data-toggle="modal"
                          data-target="#exampleModal"
                          type="button"
                        >
                          <FontAwesomeIcon icon="plus" />
                          Yeni Adres Ekle
                        </button>
                      </div>
                    </React.Fragment>
                  )}

                  <NewAddressForm />
                </div>
                <div className={"col-md-3"}>
                  <AccountWidget />
                  <CategoriesWidget />
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      );
    }
  }
}

const mapStateToProps = ({ customer, order }) => {
  return { customer, order };
};

const mapDispatchToProps = {
  customerGetAddress,
  updateActiveAddress,
  removeAddress,
};

export default connect(mapStateToProps, mapDispatchToProps)(Address);



// WEBPACK FOOTER //
// ./src/routers/Account/address.js